import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import FooterTwo from '../../components/Layout/Footer/FooterStyleTwo';
import logo from '../../assets/images/artwer/logo-dark-text.png';

const Voorwaarden = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.style.paddingTop = '';
  }, []);

  return (
    <div className="homestyle2">
      <header className="artwer-subpage-header">
        <div className="container">
          <Link to="/" aria-label="ART-WER — naar home">
            <img src={logo} className="artwer-subpage-logo" alt="ART-WER Aannemingsbedrijf" />
          </Link>
          <Link to="/" className="thm-btn-two artwer-subpage-back">Naar home</Link>
        </div>
      </header>

      <section className="artwer-legal-page">
        <div className="container">
          <h1>Algemene voorwaarden</h1>
          <p className="artwer-legal-page__meta">ART-WER Aannemingsbedrijf · KvK 54517702 · laatst bijgewerkt: juni 2026</p>

          <h2>1. Toepasselijkheid</h2>
          <p>
            Deze algemene voorwaarden zijn van toepassing op alle offertes, opdrachten en
            overeenkomsten van ART-WER Aannemingsbedrijf (hierna: ART-WER), gevestigd te
            Biddinghuizen (KvK 54517702), tenzij schriftelijk anders is overeengekomen. Afwijkingen
            gelden alleen indien deze schriftelijk zijn bevestigd.
          </p>

          <h2>2. Offertes en totstandkoming</h2>
          <p>
            Offertes zijn vrijblijvend en geldig gedurende 30 dagen, tenzij anders vermeld. Een
            overeenkomst komt tot stand na schriftelijke (of per e-mail/WhatsApp bevestigde)
            akkoordverklaring van de opdrachtgever. Genoemde prijzen zijn in euro's; of deze inclusief
            of exclusief btw zijn, wordt op de offerte vermeld.
          </p>

          <h2>3. Uitvoering van het werk</h2>
          <p>
            ART-WER voert het werk naar beste inzicht en vakmanschap uit. De opdrachtgever zorgt dat
            ART-WER tijdig kan beschikken over de benodigde toegang, aansluitingen (water/elektra) en
            informatie. Een opgegeven (oplever)planning is een indicatie en wordt in onderling overleg
            afgestemd.
          </p>

          <h2>4. Meerwerk</h2>
          <p>
            Werkzaamheden die buiten de overeengekomen opdracht vallen, gelden als meerwerk. Meerwerk
            wordt uitsluitend uitgevoerd na voorafgaande schriftelijke bevestiging van de omschrijving
            en de bijbehorende prijs, zodat de eindafrekening geen verrassingen bevat.
          </p>

          <h2>5. Oplevering</h2>
          <p>
            Het werk wordt als opgeleverd beschouwd wanneer ART-WER dit aan de opdrachtgever heeft
            meegedeeld en de opdrachtgever het werk heeft aanvaard, of het werk feitelijk in gebruik is
            genomen. Kleine gebreken die het gebruik niet in de weg staan, vormen geen reden voor
            weigering van de oplevering en worden binnen een redelijke termijn hersteld.
          </p>

          <h2>6. Betaling</h2>
          <p>
            Betaling vindt plaats binnen 14 dagen na factuurdatum, tenzij anders overeengekomen. Bij
            grotere opdrachten kan een aanbetaling of betaling in termijnen worden afgesproken. Bij
            niet-tijdige betaling is de opdrachtgever in verzuim en kunnen wettelijke rente en
            (buitengerechtelijke) incassokosten in rekening worden gebracht.
          </p>

          <h2>7. Garantie</h2>
          <p>
            ART-WER staat in voor de deugdelijke uitvoering van het werk. Op toegepaste
            materiaalsystemen (zoals Soprema ALSAN® PMMA) is de fabrieksgarantie van de betreffende
            fabrikant van toepassing, mits verwerkt conform de systeemspecificatie. Garantie vervalt
            bij ondeskundig gebruik, gebrekkig onderhoud of wijzigingen door derden.
          </p>

          <h2>8. Aansprakelijkheid</h2>
          <p>
            De aansprakelijkheid van ART-WER is beperkt tot het bedrag dat in het betreffende geval door
            de bedrijfsaansprakelijkheidsverzekering (Nationale-Nederlanden) wordt uitgekeerd, of — als
            geen uitkering plaatsvindt — tot het factuurbedrag van de opdracht. ART-WER is niet
            aansprakelijk voor indirecte of gevolgschade.
          </p>

          <h2>9. Overmacht</h2>
          <p>
            Bij overmacht (waaronder weersomstandigheden die het werk verhinderen, ziekte, of het
            uitblijven van leveringen) worden de verplichtingen opgeschort. ART-WER stemt een nieuwe
            planning met de opdrachtgever af zonder dat dit recht geeft op schadevergoeding.
          </p>

          <h2>10. Klachten</h2>
          <p>
            Klachten over het uitgevoerde werk dienen binnen 14 dagen na ontdekking schriftelijk te
            worden gemeld via <a href="mailto:info@art-wer.nl">info@art-wer.nl</a>, zodat ART-WER de
            gelegenheid heeft eventuele gebreken te herstellen.
          </p>

          <h2>11. Toepasselijk recht</h2>
          <p>
            Op alle overeenkomsten is Nederlands recht van toepassing. Geschillen worden voorgelegd aan
            de bevoegde rechter in het arrondissement waar ART-WER is gevestigd.
          </p>

          <p style={{ marginTop: '28px', fontSize: '14px', color: '#8a8a93' }}>
            Dit is een algemene versie; laat de definitieve voorwaarden vóór gebruik juridisch toetsen
            op uw situatie.
          </p>
        </div>
      </section>

      <FooterTwo />
    </div>
  );
};

export default Voorwaarden;
